module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset class="collaborateur-selecteur-view-size">\n  <input type="text" class="criteres collaborateur-selecteur-view-size" value="" />\n</fieldset>\n<div class="collaborateur-selecteur-view">\n  <div class="collab-recherche-simulation">\n    <input type="checkbox" class="collab-recherche-simulation-chk">\n    <label for="collab-recherche-simulation-chk"></label>\n  </div>\n  <br>\n  <div class="referentielcollaborateur-table"></div>\n</div>\n';
}
return __p;
};
